import { render, staticRenderFns } from "./modal-image.vue?vue&type=template&id=291049e6"
import script from "./modal-image.vue?vue&type=script&lang=ts"
export * from "./modal-image.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports